/**
 * Request class, using the (polyfilled) fetch API
 * @class
 */

const FETCH_HEADERS = [];

class Request {
    makeRequest(url, method, params, headers = []) {
        return new Promise((resolve, reject) => {
            let request = new XMLHttpRequest();

            request.open(method, url);

            request.onload = function() {
                if (request.status === 200) {
                    resolve(request.response || request.responseText);
                } else {
                    reject(Error("error code:" + request.statusText));
                }
            };
            request.onerror = function() {
                reject(Error("There was a network error."));
            };

            Object.keys(headers).forEach(key =>
                request.setRequestHeader(key, headers[key])
            );

            request.send(params);
        });
    }

    /**
     * Fetch JSON data from an URL
     * @param {string} url - The resource URL
     * @returns {Promise} - A Promise, resolving with the parsed JSON data
     */
    fetchJSON(url) {
        return this.makeRequest(url, "GET", FETCH_HEADERS).then(r =>
            JSON.parse(r)
        );
    }

    /**
     * Fetch plain text data from an URL
     * @param {string} url - The resource URL
     * @returns {Promise} - A Promise, resolving with the plain text
     */
    fetchPlainText(url) {
        return this.makeRequest(url, "GET", "", FETCH_HEADERS);
    }

    postForm(url, params) {
        return this.makeRequest(url, "POST", params, {
            "Content-type": "application/x-www-form-urlencoded"
        });
    }

    makeCalback(url, params) {
        return new Promise((resolve, reject) => {
            //todo: timout op callback voor check of er wel connectie is... > reject
            var callbackName =
                "jsonp_callback_" + Math.round(100000 * Math.random());

            window[callbackName] = function(data) {
                delete window[callbackName];
                document.body.removeChild(script);

                let matches = Array.prototype.map.call(data[1], function(obj) {
                    return obj[0];
                });

                resolve(matches);
            };

            let script = document.createElement("script");
            script.src =
                url +
                (url.indexOf("?") >= 0 ? "&" : "?") +
                "callback=" +
                callbackName +
                "&q=" +
                params;
            document.body.appendChild(script);
        });
    }

    JSONP(url, params) {
        return this.makeCalback(url, params);
    }
}

export default new Request();
